import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useVendorsApi() {
  const callApi = useApiCall();

  const FilteredServiceProviderList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.FILTERED_SERVICE_PROVIDER_LIST, data, onSuccess, onError);
  }

  const SaveVendorDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.SAVE_VENDOR_DETAILS, data, onSuccess, onError);
  }

  const GetVendorList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.GET_VENDOR_LIST, data, onSuccess, onError);
  }

  const SaveVendorFiles = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.SAVE_VENDOR_FILES, data, onSuccess, onError);
  }

  const GetVendorByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.GET_VENDOR_BY_ID, data, onSuccess, onError);
  }

  const deleteVendor = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.DELETE_VENDOR, data, onSuccess, onError);
  }

  const GetServiceType = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.GET_SERVICE_TYPE, data, onSuccess, onError);
  }

  const Exportcsv = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.EXPORT_TO_CSV, data, onSuccess, onError);
  }
  const Exportpdf = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.EXPORT_TO_PDF, data, onSuccess, onError);
  }

  const GetVendorAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.GET_VENDOR_ATTACHMENT, data, onSuccess, onError);
  }

  const FilteredServiceProviderListRedux = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.REDUX_FILTERED_SERVICE_PROVIDER_LIST, data, onSuccess, onError);
  }

  const GetVendorCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.VENDORS.GET_VENDOR_CODE, data, onSuccess, onError);
  }

  return {
    FilteredServiceProviderList,
    SaveVendorDetails,
    GetVendorList,
    GetVendorByID,
    SaveVendorFiles,
    deleteVendor,
    GetServiceType,
    Exportcsv,
    Exportpdf,
    GetVendorAttachment,
    FilteredServiceProviderListRedux,
    GetVendorCode
  };
}
